/**
 * Webhook-related types and enums for the web application.
 * These mirror the GraphQL schema types but provide cleaner enum access.
 */

export enum WebhookStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum AuthType {
  NONE = 'NONE',
  OAUTH2 = 'OAUTH2',
}

export enum WebhookEventType {
  APPLICANT_STATUS_CHANGED = 'APPLICANT_STATUS_CHANGED',
  JOB_LISTING_UPDATED = 'JOB_LISTING_UPDATED',
}

export enum DeliveryStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
